import React, { useEffect, useState } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Button, TextField, ImageUploadWithPreview } from 'src/components';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import { shallowEqual, useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { RootState } from 'src/redux/reducers';
import { fetchSetting } from 'src/redux/action/setting.action';
import { IoIosClose } from 'react-icons/io';
import { fetchDetails } from 'src/redux/action/details.action';
import Loader from 'src/components/loader';
import { AiFillExclamationCircle } from 'react-icons/ai';

interface IProps {
  socialLinks?: any;
  loading?: boolean;
}

const FORM_VALIDATION = Yup.object().shape({
  // facebook: Yup.string()
  //   .min(3, 'Facebook link must be atleast 3 characters long')
  //   .required('Facebook Link is required'),
  // instagram: Yup.string().min(
  //   3,
  //   'Instagram link must be atleast 3 characters long'
  // ),
  // tiktok: Yup.string().min(3, 'Tiktok link must be atleast 3 characters long'),
  // .required('Facebook Link is required'),
});

const OnlineOrdering: React.FC<IProps> = ({ socialLinks, loading }) => {
  const [ischecked, setIsChecked] = useState(false);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="flex items-center justify-between  scale-[0.8]">
            <h4 className="font-semibold ">Enable</h4>
            <label
              htmlFor="hasSpiceLevel"
              className="toggle inline-block w-12 h-6 bg-gray-100 rounded-full border-2 border-light-gray relative cursor-pointer"
            >
              <div
                className={`absolute w-6 h-6 rounded-[50%] -top-[2px] -left-[2px] bg-light-gray transition-transform duration-650 ${
                  ischecked ? 'transform translate-x-full bg-primary' : ''
                }`}
              ></div>
              <input
                type="checkbox"
                id="hasSpiceLevel"
                name="hasSpiceLevel"
                className="hidden"
                checked={ischecked}
                onChange={() => setIsChecked(ischecked)}
              />
            </label>
          </div>
          <div className="italic flex  mt-2 block">
            <div>
              <AiFillExclamationCircle size={30} style={{ color: 'gray' }} />
            </div>
            <div className="mt-1 ml-1">
              Please upgrade your plan to{' '}
              <span className="font-bold">PREMIUM </span> to enable online
              ordering for your restaurant.
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default React.memo(OnlineOrdering);
